import { createFileRoute, redirect } from '@tanstack/react-router';

import { ensureMediaByIdQueryData } from '@/api/media';
import { ImagesBreadcrumb } from '@/features/estates/components/imagesBreadcrumb';
import { getEstate } from '@/features/estates-property/api/estate';
import { requireMediaWrite } from '@/features/permissions/route-permissions';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/edit/$mediaId/'
)({
  loader: async (props) => {
    const estate = await getEstate(props.params.estateId);

    requireMediaWrite(estate.metadata?.permissions, {
      type: 'estate',
      estateId: props.params.estateId,
    });

    try {
      return await ensureMediaByIdQueryData(props);
    } catch {
      throw redirect({
        to: '/estates/$estateId/media',
        params: { estateId: props.params.estateId },
      });
    }
  },
  staticData: {
    breadcrumb: () => <ImagesBreadcrumb labels={['Image Editor']} />,
  },
});
